import React, { useRef, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { INSPECTION_MODES } from '../data/experience';

export default function InspectionLab() {
  const [modeId, setModeId] = useState('paint');
  const [position, setPosition] = useState(54);
  const wrap = useRef(null);
  const reduceMotion = useReducedMotion();
  const mode = INSPECTION_MODES.find((item) => item.id === modeId);

  const move = (clientX) => {
    const box = wrap.current?.getBoundingClientRect();
    if (!box) return;
    setPosition(Math.max(4, Math.min(96, ((clientX - box.left) / box.width) * 100)));
  };

  return (
    <section className="inspection-lab px-6 md:px-10 py-24 md:py-32 bg-charcoal text-white" data-testid="inspection-lab">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-10">
        <div className="lg:col-span-7">
          <p className="eyebrow">02 / Inspection lab</p>
          <h2 className="font-display h-section mt-5 text-white">Move the <span className="text-red">inspection light.</span></h2>
        </div>
        <p className="lg:col-span-5 text-white/60 body-lg">Switch modes, then drag or use the slider. These visuals explain the effect—they are illustrative, not a measured product simulation.</p>
      </div>
      <div className="inspection-tabs" role="tablist" aria-label="Inspection mode">
        {INSPECTION_MODES.map((item) => <button key={item.id} role="tab" aria-selected={modeId === item.id} onClick={() => setModeId(item.id)} className={modeId === item.id ? 'active' : ''}>{item.title}</button>)}
      </div>
      <motion.div key={mode.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: reduceMotion ? 0 : .35 }}>
        <div ref={wrap} className="inspection-canvas" onPointerMove={(e) => e.buttons === 1 && move(e.clientX)} onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); move(e.clientX); }}>
          <img src={mode.image} alt={`${mode.title} comparison before state`} style={{ filter: mode.filterBefore }} />
          <div className="inspection-reveal" style={{ width: `${position}%` }}>
            <img src={mode.image} alt={`${mode.title} comparison after state`} style={{ filter: mode.filterAfter }} />
          </div>
          <div className="inspection-line" style={{ left: `${position}%` }} />
          <span className="inspection-label left">{mode.before}</span>
          <span className="inspection-label right">{mode.after}</span>
        </div>
        <label className="inspection-range-label">
          <span className="sr-only">Comparison position</span>
          <input aria-label={`${mode.title} comparison position`} type="range" min="4" max="96" value={Math.round(position)} onChange={(e) => setPosition(Number(e.target.value))} />
        </label>
      </motion.div>
    </section>
  );
}
